<template>
  <section id="section__select" class="view-container">
    <div class="width-100">
      <v-row cols="12" class="mb-10 mt-10" no-gutters>
        <v-col cols="12">
          <p class="mb-5 font--m-3">
            사입 품목을 <br />
            확인해주세요.
          </p>
          <LogoText />
        </v-col>
      </v-row>

      <v-row class="mb-10 mt-10" no-gutters>
        <v-col cols="12">
          <v-card class="credit-purchase-card">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card-text class="justify-center font--m-5">주문 거래처</v-card-text>
                <v-card-text class="justify-center color--buynow font--m-5">3</v-card-text>
              </v-col>
              <v-col cols="4">
                <v-card-text class="justify-center font--m-5">주문 품목</v-card-text>
                <v-card-text class="justify-center color--buynow font--m-5">15</v-card-text>
              </v-col>
              <v-col cols="4">
                <v-card-text class="justify-center font--m-5">주문 수량</v-card-text>
                <v-card-text class="justify-center color--buynow font--m-5">42</v-card-text>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="6">
                <v-card-text class="justify-center font--m-5">총 사입 금액</v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="justify-center color--buynow font--m-5"
                  >395,000
                  <span class="justify-center color--black font--m-5">원</span></v-card-text
                >
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mb-10 mt-10" no-gutters>
        <v-col cols="12">
          <p class="color--pinkred-110 font--m-5">
            ※ 외상 구매 금액은 <span class="color--black">1시간 이내</span>에 <br />
            거래상점에게 송금됩니다.
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" class="mt-5">
          <BasicButton @click="confirmCredit(credit)">외상하기</BasicButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {},
  data() {
    return {
      credit: null,
      creditApplyDialog: false,
    }
  },
  methods: {
    ...mapActions('product', ['getProductsDetail', 'confirmCredits']),
    async confirmCredit(credit) {
      this.credit = await this.confirmCredits(credit.uuid)
      this.$router.push(`/credits/${credit.uuid}/complete`)
    },
    // async test() {
    //   const tempValue = '995,000'
    //   const confirm = await this.$swal.basic.confirm({
    //     html: `총 외상금액 <br /><span class="color--buynow">${tempValue}</span> 원을 외상 신청합니다`,
    //   })
    //   // 확인 눌렀을 때, 다음 페이지로 넘어감
    //   if (confirm.isConfirmed === true) {
    //     this.confirmCredit(this.credit)
    //   }
    // },
  },
  // watch: {
  //   credit(v) {
  //     if (v.status !== 'save') {
  //       this.$router.push(`/credits/${v.uuid}/complete`)
  //     }
  //   },
  // },
  async created() {
    this.credit = await this.getProductsDetail(this.$route.params.uuid)
    // this.creditItem = this.credit.itemSet
    // // 외상 구매금 총합 계산
    // this.creditSum = this.creditItem.reduce(
    //   (accumulator, item) => accumulator + item.purchaseUnitCost,
    //   0,
    // )
  },
}
</script>
<style lang="scss" scoped>
#section__select {
  text-align: center;
}
</style>
